import { c as _c } from "react/compiler-runtime";
import { Input } from '@xefi/x-react/form';
import { useDebouncedValue } from '@xefi/x-react/hooks';
import { mergeTailwindClasses } from '@xefi/x-react/utils';
import type React from 'react';
import { useEffect, useRef, useState } from 'react';
type ClearableInputProps = React.ComponentProps<typeof Input> & {
  onValueChange?: (value: string) => void;
  debounceMs?: number;
};
export const ClearableInput = t0 => {
  const $ = _c(17);
  let onValueChange;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      onValueChange,
      debounceMs: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onValueChange;
    $[2] = props;
    $[3] = t1;
  } else {
    onValueChange = $[1];
    props = $[2];
    t1 = $[3];
  }
  const debounceMs = t1 === undefined ? 0 : t1;
  if (debounceMs === 0) {
    const t2 = props.classNames;
    const t3 = props.classNames?.inputWrapper;
    let t4;
    if ($[4] !== t3) {
      t4 = mergeTailwindClasses("border-border h-10 rounded-md m-0 w-full", t3);
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== props.classNames || $[7] !== t4) {
      t5 = {
        ...t2,
        inputWrapper: t4
      };
      $[6] = props.classNames;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== onValueChange || $[10] !== props || $[11] !== t5) {
      t6 = <Input {...props} classNames={t5} isClearable={true} onValueChange={onValueChange} radius="md" />;
      $[9] = onValueChange;
      $[10] = props;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t2;
  if ($[13] !== debounceMs || $[14] !== onValueChange || $[15] !== props) {
    t2 = <DebouncedInput {...props} onValueChange={onValueChange} debounceMs={debounceMs} />;
    $[13] = debounceMs;
    $[14] = onValueChange;
    $[15] = props;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  return t2;
};
const DebouncedInput = ({
  onValueChange,
  debounceMs = 300,
  value: externalValue,
  ...props
}: ClearableInputProps & {
  value?: string;
}) => {
  const [localValue, setLocalValue] = useState(externalValue || '');
  const {
    debouncedValue
  } = useDebouncedValue(localValue, debounceMs);
  useEffect(() => {
    if (externalValue !== undefined) {
      setLocalValue(externalValue);
    }
  }, [externalValue]);
  const prevDebouncedValueRef = useRef(debouncedValue);
  if (prevDebouncedValueRef.current !== debouncedValue && onValueChange) {
    onValueChange(debouncedValue);
    prevDebouncedValueRef.current = debouncedValue;
  }
  return <Input {...props} classNames={{
    ...props.classNames,
    inputWrapper: mergeTailwindClasses('border-border h-10', props.classNames?.inputWrapper)
  }} isClearable value={localValue} onValueChange={setLocalValue} radius='md' />;
};